export default "/images/6fe39b21baca245aff1d71c0baac322f.avif";